// RickyMartini 商品頁轉換優化
// 1. 預設尺寸：連結未指定款式、且系統預選落在最小號 XS 時，改選有庫存的 M。
// 2. 手機固定加購列：主要「加入購物車」按鈕捲出畫面上方後，於底部顯示目前款式、價格與加購按鈕；
//    按下即觸發原本的加購按鈕，沿用相同的商品表單與購物車通知。
//    切換款式時 Dawn 會重新渲染商品區塊並換掉按鈕元素，所以每次都重新查詢按鈕，不固定觀察單一元素。
// 3. 尺寸表連結：「尺寸」旁的「尺寸表」按鈕捲到商品說明裡的尺寸表。
(function () {
  function findSizeFieldset() {
    var selects = document.querySelector('variant-selects');
    if (!selects) return null;
    return Array.prototype.find.call(selects.querySelectorAll('fieldset'), function (fieldset) {
      var legend = fieldset.querySelector('legend');
      return legend && legend.textContent.trim().indexOf('尺寸') === 0;
    });
  }

  function preferSizeM() {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    var fieldset = findSizeFieldset();
    if (!fieldset) return;
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (!checked || checked.value !== 'XS') return;
    var preferred = Array.prototype.find.call(fieldset.querySelectorAll('input[type="radio"]'), function (input) {
      return input.value === 'M' && !input.disabled && !input.classList.contains('disabled');
    });
    if (!preferred) return;
    preferred.checked = true;
    preferred.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function selectedOptionsText() {
    var selects = document.querySelector('variant-selects');
    if (!selects) return '';
    return Array.prototype.map
      .call(selects.querySelectorAll('fieldset input[type="radio"]:checked'), function (input) {
        return input.value;
      })
      .join(' / ');
  }

  function currentPriceText() {
    var price = document.querySelector('product-info .price .price-item--last, product-info .price .price-item--regular');
    return price ? price.textContent.trim().replace(/\s*TWD$/, '') : '';
  }

  function initStickyAddToCart() {
    function currentButton() {
      return document.querySelector('product-info button[name="add"]');
    }
    if (!currentButton()) return;

    var bar = document.createElement('div');
    bar.className = 'rm-sticky-atc';
    bar.hidden = true;
    bar.innerHTML =
      '<div class="rm-sticky-atc__info">' +
      '<span class="rm-sticky-atc__variant"></span>' +
      '<span class="rm-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="button button--primary rm-sticky-atc__button">加入購物車</button>';
    document.body.appendChild(bar);

    var variantLabel = bar.querySelector('.rm-sticky-atc__variant');
    var priceLabel = bar.querySelector('.rm-sticky-atc__price');
    var stickyButton = bar.querySelector('.rm-sticky-atc__button');

    function sync() {
      var button = currentButton();
      if (!button) return;
      variantLabel.textContent = selectedOptionsText();
      priceLabel.textContent = currentPriceText();
      stickyButton.disabled = button.disabled;
      // 沿用主按鈕文字，預購款式會一起顯示「預購」。
      var label = button.querySelector('span');
      stickyButton.textContent = (label && label.textContent.trim()) || (button.disabled ? '已售完' : '加入購物車');
    }

    function setVisible(visible) {
      if (visible) sync();
      if (bar.hidden === !visible) return;
      bar.hidden = !visible;
      document.body.classList.toggle('rm-sticky-atc-visible', visible);
    }

    var ticking = false;
    function update() {
      ticking = false;
      var button = currentButton();
      setVisible(!!button && button.getBoundingClientRect().bottom < 0);
    }
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();

    stickyButton.addEventListener('click', function () {
      var button = currentButton();
      if (button && !button.disabled) button.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.setTimeout(sync, 0);
      });
    }
  }

  function initSizeChartLink() {
    // 切換款式時 Dawn 會重新渲染選擇器，所以用事件委派，不綁在單一按鈕上。
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-rm-size-chart]');
      if (!trigger) return;
      event.preventDefault();
      var heading = Array.prototype.find.call(
        document.querySelectorAll('main h2, main h3, main h4, main summary'),
        function (el) {
          return el.textContent.indexOf('尺寸表') !== -1;
        }
      );
      if (!heading) return;
      var details = heading.closest('details');
      if (details) details.open = true;
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init() {
    preferSizeM();
    initStickyAddToCart();
    initSizeChartLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
